import { WaterMinusIcon } from './WaterMinusIcon';

/**
 * author: Colton Wiscombe
 * id C3824C0D-87B1-4577-A060-EDE628A694BC
 * name water-minus
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-minus.svg
 * tags
 */
export const BloodMinusIcon = WaterMinusIcon;
export default BloodMinusIcon